module.exports = __webpack_public_path__ + "static/4_mobile-ce715fb2e049aa2d70e368c949377e3c.jpg";